export default __webpack_public_path__ + "static/media/powered_by_mydna-logo.f501ab3a.svg";